import React from "react";
import { Truck } from "lucide-react";

export default function AnnouncementBar() {
    return (
        <div
            data-testid="announcement-bar"
            className="bg-forest-900 text-gold-400 text-[11px] sm:text-sm font-medium py-2.5 px-4 text-center tracking-wide flex items-center justify-center gap-2 shadow-inner"
        >
            <Truck
                className="w-4 h-4 text-gold-400 animate-bob"
                strokeWidth={2.5}
            />
            <span>
                <strong>FREE Cash on Delivery Nationwide</strong>
                <span className="hidden sm:inline">
                    {" "}| Free Delivery · 100% PCSIR Certified
                </span>
            </span>
        </div>
    );
}
